// test1817
(1817 && 0);
